import { render } from "./IconOttApp.vue?vue&type=template&id=3dc14f61"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconOttApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dc14f61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dc14f61', __exports__)) {
    api.reload('3dc14f61', __exports__)
  }
  
  module.hot.accept("./IconOttApp.vue?vue&type=template&id=3dc14f61", () => {
    api.rerender('3dc14f61', render)
  })

}


export default __exports__